var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28",
    "data-name": "Group 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.349,
    height: 47,
    viewBox: "0 0 44.349 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.599,
    y1: -3.005,
    x2: -0.539,
    y2: -3.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#352b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a9ce"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M209,270.953a11.383,11.383,0,0,0-9.771,5.728,31.959,31.959,0,0,0-3.6,8.949,39.943,39.943,0,0,0-1.1,9.37,36.611,36.611,0,0,0,2.558,13.823c1.831,4.392,4.568,7.65,7.947,8.752,3.9,1.27,9.925-.9,15.819-4.48,9.174-5.571,18.025-14.55,18.025-19.268a3.32,3.32,0,0,0-.044-.547c0-.008,0-.015,0-.024a16.1,16.1,0,0,0-2.426-5.711C231.112,279.265,218.654,270.552,209,270.953Z",
    transform: "translate(-194.525 -270.94)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(10.807 13.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M234.429,311.774c-1.932,0-2.223,1.512-2.223,3.064v5.914h-3.72V308.8h3.569v1.636h.047a3.906,3.906,0,0,1,3.52-1.934c3.762,0,4.452,2.478,4.452,5.695v6.556h-3.713v-5.81C236.361,313.554,236.332,311.774,234.429,311.774Z",
    transform: "translate(-222.143 -302.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.727,
    height: 11.954,
    transform: "translate(0.291 5.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M218.331,297.562a2.154,2.154,0,1,1-2.153,2.148A2.146,2.146,0,0,1,218.331,297.562Z",
    transform: "translate(-216.178 -297.562)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi3);
export default __webpack_public_path__ + "static/media/si3.3374d25e92a25ced3d8c38dd5ec11c53.svg";
export { ForwardRef as ReactComponent };